exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".src-components-profile-UserLoginInfo-label{margin-left:10px;color:#929292}.src-components-profile-UserLoginInfo-companyLink{margin-left:10px}", ""]);

// exports
exports.locals = {
	"label": "src-components-profile-UserLoginInfo-label",
	"companyLink": "src-components-profile-UserLoginInfo-companyLink"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"modules":true,"localIdentName":"[path][local]"}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./node_modules/sass-loader/dist/cjs.js!./src/components/profile/UserLoginInfo/styles.scss
// module id = ./node_modules/css-loader/index.js?{"importLoaders":1,"modules":true,"localIdentName":"[path][local]"}!./node_modules/postcss-loader/lib/index.js?{"ident":"postcss","plugins":[null,null]}!./node_modules/sass-loader/dist/cjs.js!./src/components/profile/UserLoginInfo/styles.scss
// module chunks = 1